<template>
  <div class="jImportFile jTableReport">
    <v-client-table
      :data="tableData"
      :options="options"
      :columns="columns"
      class="jTable"/>

    <div class="float-to-right">
      <slot/>
      <b-button
        :disabled="disabled"
        class="btn blue"
        @click="importData">Import</b-button>
    </div>

  </div>
</template>

<script>


export default {
  props: {
    tableData: {
      type: Array,
      default: null,
    },
    columns: {
      type: Array,
      default: null,
    },
    invalidHeader: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      options: {
        columnsClasses: this.invalidHeader,
      },
      disabled: (Object.keys(this.invalidHeader).length > 0),
    };
  },
  computed: {
    sortable() {
      // eslint-disable-next-line
      const datas = this.columns.filter((data, index) => {
        if (index !== 0) {
          return data;
        }
      });
      return datas;
    },
  },
  created() {
    // this.tableData.splice(0, 1);
  },
  mounted() {
    const elem = document.getElementsByClassName('form-control');
    elem[0].setAttribute('placeholder', 'Search');
  },
  methods: {
    importData() {
      this.$emit('importData', this.tableData);
    },

  },
};
</script>

<style lang="scss">
.invalid {
  border: 2px solid rgb(189, 43, 24) !important;
}
.table-responsive {
  margin-bottom: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/import/jTablePreview.vue